/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolRiceBowlIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-rice-bowl"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9 22.32Q8.45 22.32 8.06 21.94Q7.67 21.55 7.67 21L7.67 20.48Q5.03 19.35 3.35 17.09Q1.68 14.82 1.68 12Q1.68 9.85 2.49 7.97Q3.3 6.1 4.7 4.7Q6.1 3.3 7.99 2.49Q9.88 1.68 12.01 1.68Q14.15 1.68 16.02 2.49Q17.9 3.3 19.3 4.7Q20.7 6.1 21.51 7.97Q22.32 9.85 22.32 12Q22.32 14.82 20.65 17.09Q18.98 19.35 16.32 20.48L16.32 21Q16.32 21.55 15.94 21.94Q15.55 22.32 15 22.32ZM10.32 11.68L13.68 11.68L13.68 4.5Q13.25 4.4 12.84 4.36Q12.43 4.33 12 4.33Q11.57 4.33 11.16 4.36Q10.75 4.4 10.32 4.5ZM4.33 11.68L7.67 11.68L7.67 5.65Q6.17 6.7 5.29 8.28Q4.4 9.85 4.33 11.68ZM16.32 11.68L19.68 11.68Q19.6 9.85 18.71 8.28Q17.82 6.7 16.32 5.65Z" fill={color} />
    </svg>
  );
}
